/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ExpenseDetailEditor extends _Ext.GridEditorBase<PaymentDetailsRow> {
        protected getColumnsKey() { return "Finance.ExpenseDetail"; }
        protected getDialogType() { return ExpenseDetailDialog; }
        protected getLocalTextPrefix() { return ExpenseDetailRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        constructor(container: JQuery) {
            super(container);
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ExpenseDialog).CalculateTotals();
                }
            })
        }

        
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }

            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}